import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventInviteRevoke } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventInviteRevoke) => void

export const useEventCancelInvite = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.InvitationRevoked, handler), [])
}
